<div class="details-section">
  <ul>
    <li>Curso: {{ curso?.curso }}</li>
    <li>Sigla: {{ curso?.cursoSigla }}</li>
    <li>Unidade Orgânica: {{ curso?.instituicaoEnsino }}</li>
  </ul>

  <div class="div-accordion-header">
    <h4>Plano Curricular</h4>
    <p-button icon="pi pi-pencil" [label]="planoCurricular ? 'Editar Plano Curricular' : 'Criar Plano Curricular'"
      class="p-button-primary" (click)="abrirPlanoCurricular()"></p-button>
    <!-- <p-button *ngIf="!planoCurricular" icon="pi pi-plus" label="Criar Plano Curricular" class="p-button-primary" (click)="visiblePlanoCurricularForm = true"></p-button> -->
  </div>

  <app-plano-curricular-cadastrar-editar *ngIf="curso" [visiblePlanoCurricularForm]="visiblePlanoCurricularForm"
    [planoCurricular]="planoCurricular" [instituicaoDeEnsinoCursoID]="curso.id"
    (savePlanoCurricularEvent)="onPlanoCurricularSaved($event)"
    (close)="visiblePlanoCurricularForm = false"></app-plano-curricular-cadastrar-editar>

  <ul *ngIf="planoCurricular">
    <li>{{ planoCurricular?.designacao}}</li>
    <li>{{ planoCurricular?.cargaHoraria}} horas</li>
    <li>{{ planoCurricular?.quantidadeAnosCurricular}} anos curriculares</li>
  </ul>

  <p-accordion [style]="{ width: '100%' }" [(activeIndex)]="activeIndex"
    (activeIndexChange)="onAccordionTabOpen(planoCurricular?.id, $event)"
    *ngIf="planoCurricular; else semPlanoCurricular">
    <p-accordionTab *ngFor="let ano of [].constructor(planoCurricular?.quantidadeAnosCurricular); let i = index"
      [header]="(i + 1) + 'º Ano'" (onOpen)="onAccordionTabOpen(planoCurricular?.id, (i + 1))">
      <div class="flex justify-content-end  mb-2">
        <p-button label="Adicionar Disciplina" class="p-button-primary"
          (click)="showDisciplinaDialog(i + 1)"></p-button>
      </div>

      <!-- Tabela de Disciplinas -->
      <app-table *ngIf="pagination?.data?.length; else noData" [pagination]="pagination" [columns]="columns"
        [actions]="actions" (pageChange)="onPageChange($event)"></app-table>

      <!-- Modal de Disciplina -->
      <app-plano-curricular-disciplina-cadastrar-editar *ngIf="visibleDisciplinaForm"
        [visibleDisciplinaForm]="visibleDisciplinaForm" [disciplinaOptions]="disciplinaOptions"
        [disciplina]="disciplina" [isLoading]="isLoading" [tipoPedidoList]="tipoPeriodoList"
        (close)="visibleDisciplinaForm = false" (changeTipoPedido)="onTipoPedidoChange($event)"
        [periodoList]="periodoList" [planoCurricularID]="planoCurricular?.id" [anoCurricular]="i + 1"
        (saveDisciplinaEvent)="onDisciplinaSaved($event)"></app-plano-curricular-disciplina-cadastrar-editar>

      <!-- Mensagem de Nenhuma Disciplina -->
      <ng-template #noData>
        <div class="no-data">
          <app-data-void titulo="Nenhuma disciplina encontrada"
            descricao="Clique em adicionar disciplina"></app-data-void>
        </div>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
  <ng-template #semPlanoCurricular>
    <div class="no-data">
      <app-data-void titulo="Nenhum plano curricular encontrado"
        descricao="Clique em criar plano curricular"></app-data-void>
    </div>
  </ng-template>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>